//* Libraries imports
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { CircularProgress, Tabs, Tab } from "@material-ui/core";

//* Components
import DefaultButton from "../ReusableComponents/DefaultButton";
import TabPanel from "../ReusableComponents/TabPanel";
import AvaliacaoModal from "./components/AvaliacaoModal";
import InscricaoHeader from "./components/InscricaoHeader";
import DadosPessoaisPanel from "./components/DadosPessoaisPanel";
import DadosContatoPanel from "./components/DadosContatoPanel";
import DadosExamePanel from "./components/DadosExamePanel";
import InfoAvaliacaoPanel from "./components/InfoAvaliacaoPanel";
import DocumentosPanel from "./components/DocumentosPanel";
import CriterioSelecaoPanel from "./components/CriterioSelecaoPanel";
import EnemNotesPanel from "./components/EnemNotesPanel";

//* Constants
import { URL } from "../../variables";

class ShowIncricoes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: "/inscricoes/avaliar",
      loading_screen: true,
      inscricao: null,
      msgErro: "",
      activeTab: 0,
      alert: null,
    };
    this.avaliacaoModalRef = React.createRef();
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id) this.getInscricao(id);
  }

  getInscricao(id) {
    if (this.state.loading_screen === false)
      this.setState({ loading_screen: true });

    fetch(`${URL}api/inscricoes/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${this.props.token}`,
      },
    })
      .then(async (responseLog) => {
        try {
          const resp = await responseLog.json();

          if (resp?.message === "Unauthenticated.") {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            this.props.logout && this.props.logout();
            return;
          }

          if (
            resp?.errors != null ||
            resp?.error != null ||
            resp?.result === false
          ) {
            const errors = Object.values(resp.errors || {});
            let erro = "";
            for (let i = 0; i < errors.length; i++) {
              erro += i !== errors.length - 1 ? errors[i] + "\n" : errors[i];
            }
            this.setState({ redirect: true, msgErro: erro });
          } else {
            const data = resp?.data ?? resp;
            this.setState({ loading_screen: false, inscricao: data });
          }
        } catch (err) {
          this.setState({
            redirect: true,
            msgErro: "Erro ao buscar inscrição.",
          });
          console.log(err);
        }
      })
      .catch((err) => {
        this.setState({
          redirect: true,
          msgErro: "Erro de conexão ao buscar inscrição.",
        });
        console.log(err);
      });
  }

  renderCampo(label, valor, opts = {}) {
    const { transform = (v) => v, placeholder = "-" } = opts;
    const v =
      valor === null || valor === undefined || valor === ""
        ? placeholder
        : transform(valor);
    return (
      <div style={{ marginBottom: 10 }}>
        <b style={{ color: "black" }}>{label}: </b>
        <span>{v}</span>
      </div>
    );
  }

  formatSexo(v) {
    if (!v) return "-";
    const map = { M: "Masculino", F: "Feminino", O: "Outro" };
    return map[v] || v;
  }

  formatLingua(v) {
    if (!v) return "-";
    const map = { ingles: "Inglês", espanhol: "Espanhol" };
    return map[v] || v;
  }

  formatNivel(v) {
    if (!v) return "-";
    const map = { fundamental: "Fundamental", medio: "Médio" };
    return map[v] || v;
  }

  formatStatus(v) {
    if (!v) return "-";
    const map = {
      deferida: "Deferida",
      indeferida: "Indeferida",
      pendente: "Pendente",
    };
    return map[v] || v;
  }

  formatSimNao(v) {
    if (v === undefined || v === null) return "-";
    const s = String(v).toLowerCase();
    if (["sim", "true", "1"].includes(s)) return "Sim";
    if (["nao", "não", "false", "0"].includes(s)) return "Não";
    return v;
  }

  formatCriterioSelecao(v) {
    if (!v) return "-";
    const map = {
      sisu: "Sistema de Seleção Unificada(Nivel Ensino Médio) – SISU",
      prouni_fies:
        "Programa Universidade para Todos e Fundo de Financiamento Estudantil - PROUNI / FIES",
      faculdade_privada_enem:
        "Aprovação em Faculdade Privada *Vestibular ou acesso através da nota no ENEM – EXAME NACIONAL DO ENSINO MÉDIO",
      estagio_jovem_aprendiz:
        "Seleção de Estágio / Jovem Aprendiz (Níveis Ensino Fundamental e Médio) - Emprego Privado",
      emprego_privado:
        "Seleção para Emprego Privado (Níveis Ensino Fundamental e Médio) - Emprego Privado",
      concurso: "Aprovação em Concurso - Concurso",
    };
    const key = String(v).toLowerCase();
    return map[key] || v;
  }

  getCriterioKey(inscricao) {
    const v = inscricao?.criterioSelecao ?? inscricao?.criterio_selecao ?? "";
    return String(v || "").toLowerCase();
  }

  getCriterioInfo(key) {
    const docs = {
      sisu: [
        "Certidão de nascimento ou casamento",
        "RG",
        "CPF",
        "Histórico Escolar original",
        "Declaração da Instituição de Ensino Superior",
        "Resultado final individual (nome, curso, com aprovação na chamada regular)",
        "Página do Edital da Instituição de Ensino Superior na qual consta o calendário de matrícula",
      ],
      prouni_fies: [
        "Certidão de nascimento ou casamento",
        "RG",
        "CPF",
        "Histórico Escolar original",
        "Declaração da Instituição de Ensino Superior",
        "Resultado final individual com (aprovação) na qual conste o nome do candidato, nome da Instituição de nível superior e período de matrícula",
      ],
      faculdade_privada_enem: [
        "Certidão de nascimento ou casamento",
        "RG",
        "CPF",
        "Histórico Escolar original",
        "Declaração da Instituição de Ensino Superior",
        "Declaração ou informação apresentada no site oficial da instituição de ensino superior que realizou o vestibular, contendo as seguintes informações: nome do estudante, número de sua carteira de identidade - RG, data da realização do vestibular ou seleção, assinatura e carimbo do responsável pela Instituição, nome do curso, ano e o semestre para o qual o estudante terá direito à matrícula na Instituição de Ensino Superior, como exemplo, 2018.1 ou 2018.2, (primeiro ou segundo semestre do ano corrente).",
        "Histórico ENEM",
      ],
      estagio_jovem_aprendiz: [
        "Certidão de nascimento ou casamento",
        "RG",
        "CPF",
        "Declaração de comprovação e aprovação para seleção de Estágio ou Jovem Aprendiz",
      ],
      emprego_privado: [
        "Certidão de nascimento ou casamento",
        "RG",
        "CPF",
        "Declaração de aprovação em seleção para emprego privado com função a assumir ou permanecer.",
      ],
      concurso: [
        "Certidão de nascimento ou casamento",
        "RG",
        "CPF",
        "Documentação comprobatória original de aprovação em concurso e/ou exame de seleção",
      ],
    };
    return docs[key] || [];
  }

  getExamesAnteriores(inscricao) {
    const lista =
      inscricao?.examesAnteriores || inscricao?.exames_anteriores || [];
    if (!Array.isArray(lista)) return [];
    return lista.map((e, idx) => {
      const nome = e.exame_nome || e.nome || `Exame ${idx + 1}`;
      const anos = e.exame_anos || e.anos || "-";
      const caminho =
        e.exame_documento_caminho ||
        e.documento_caminho ||
        e.arquivoCaminho ||
        "";
      const nomeOriginal =
        e.exame_documento_nome_original ||
        e.documento_nome_original ||
        e.arquivoNomeOriginal ||
        "";
      const tipo = e.exame_documento_tipo || e.documento_tipo || "";
      const tamanho = e.exame_documento_tamanho || e.documento_tamanho || "";
      return { nome, anos, caminho, nomeOriginal, tipo, tamanho };
    });
  }

  render() {
    const { inscricao, loading_screen } = this.state;
    const enemData =
      inscricao?.aproveitamentoNotasExternas ||
      inscricao?.aproveitamento_notas_externas;
    const showEnemTab = enemData && enemData.tipo === "enem";

    if (loading_screen) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <CircularProgress />
        </div>
      );
    }

    if (!inscricao) {
      return (
        <div className="card">
          <div className="card-body">
            <p style={{ textAlign: "center" }}>Inscrição não encontrada</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 16,
              }}
            >
              <DefaultButton
                bg="secondary"
                text="Voltar"
                to={this.state.path}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={{ position: "relative" }}>
        {this.state.redirect === true && <Redirect to={this.state.path} />}
        <div className="card">
          <div className="card-body">
            <InscricaoHeader
              inscricao={inscricao}
              onBackPath={this.state.path}
              onEvaluate={() =>
                this.avaliacaoModalRef.current.openModalAvaliacao(inscricao)
              }
              formatStatus={this.formatStatus}
            />

            <Tabs
              value={this.state.activeTab}
              onChange={(e, v) => this.setState({ activeTab: v })}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
            >
              <Tab label="Dados Pessoais" />
              <Tab label="Dados de Contato" />
              <Tab label="Dados do Exame" />
              <Tab label="Documentação" />
              <Tab label="Critério de Seleção" />
              {showEnemTab && <Tab label="Notas ENEM" />}
            </Tabs>

            <TabPanel value={this.state.activeTab} index={0}>
              <DadosPessoaisPanel
                inscricao={inscricao}
                renderCampo={this.renderCampo}
                formatSexo={this.formatSexo}
              />
            </TabPanel>

            <TabPanel value={this.state.activeTab} index={1}>
              <DadosContatoPanel
                inscricao={inscricao}
                renderCampo={this.renderCampo}
              />
            </TabPanel>

            <TabPanel value={this.state.activeTab} index={2}>
              <div className="row">
                <div className="col-md-6">
                  <DadosExamePanel
                    inscricao={inscricao}
                    renderCampo={this.renderCampo}
                    formatLingua={this.formatLingua}
                    formatNivel={this.formatNivel}
                    getExamesAnteriores={this.getExamesAnteriores}
                  />
                </div>
                <div className="col-md-6">
                  <InfoAvaliacaoPanel
                    inscricao={inscricao}
                    renderCampo={this.renderCampo}
                  />
                </div>
              </div>
            </TabPanel>

            <TabPanel value={this.state.activeTab} index={3}>
              <DocumentosPanel inscricao={inscricao} />
            </TabPanel>

            <TabPanel value={this.state.activeTab} index={4}>
              <CriterioSelecaoPanel
                inscricao={inscricao}
                formatCriterioSelecao={this.formatCriterioSelecao}
                getCriterioKey={this.getCriterioKey}
                getCriterioInfo={this.getCriterioInfo}
              />
            </TabPanel>

            {showEnemTab && (
              <TabPanel value={this.state.activeTab} index={5}>
                <EnemNotesPanel inscricao={inscricao} />
              </TabPanel>
            )}
          </div>
        </div>

        <AvaliacaoModal
          ref={this.avaliacaoModalRef}
          inscricao={inscricao}
          token={this.props.token}
          logout={this.props.logout}
          onSaveSuccess={this.getInscricao.bind(this, inscricao.id)}
        />

        {this.state.alert}
      </div>
    );
  }
}

const mapsStateToProps = (state) => ({
  user: state.AppReducer.user,
  token: state.AppReducer.token,
});

export default connect(mapsStateToProps, {})(ShowIncricoes);
